import React, { ChangeEvent } from 'react';

import classNames from 'classnames';

import StepDescription from '../StepDescription/StepDescription';

import { ReportList, TypeOfReport } from './ReportType.data';

import './ReportSelector.scss';

export interface ReportSelectorProps {
  isGroup: boolean;
  hasChildren: boolean;
  defultReport: TypeOfReport;
  onReportTypeChange: (value: TypeOfReport) => void;
}

const ReportSelector = ({
  isGroup,
  hasChildren,
  defultReport,
  onReportTypeChange,
}: ReportSelectorProps) => {
  const reportTypeView = ReportList.map((report) => {
    return (
      <div className="stats-report-selector__type" key={report.name}>
        <span className="stats-report-selector__label"> {report.name}:</span>
        <p className="stats-report-selector__description">{report.description}</p>
        {report.data.map((type) => {
          const hideIfGroup =
            (type.key === 'UGR' || type.key === 'DUBG' || type.key === 'SUBG') && !isGroup;
          const hideReport =
            ((type.key === 'ISR' || type.key === 'SRISR') && !hasChildren) || hideIfGroup;

          return (
            <div
              className={classNames('vol-form__check', hideReport && 'stats-report-selector--hide')}
              key={type.key}
            >
              <label className="vol-form__check-label">
                <input
                  name="radio"
                  type="radio"
                  className="mr-2"
                  id={`${type.key.toLowerCase()}-report`}
                  value={type.key}
                  checked={defultReport === type.key}
                  onChange={(e: ChangeEvent<HTMLInputElement>) =>
                    onReportTypeChange(e.target.value as TypeOfReport)
                  }
                />
                {type.value}
              </label>
            </div>
          );
        })}
      </div>
    );
  });

  return (
    <div className="stats-report-selector">
      <div className="stats-report-selector__section-title">
        <StepDescription order="1" description="Select the report you wish to view" />
      </div>

      <div className="stats-report-selector__section-element">{reportTypeView}</div>
    </div>
  );
};

export default ReportSelector;
